// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer {
  font-family: "CreatoDisplay", sans-serif; 
  font-weight: 500; 
  display: flex;
  justify-content: flex-start; /* Alinea ambos a la izquierda */
  padding: 10px;
  font-size: 10px;
  background-color: transparent; /* Sin fondo */
  color: #000000;
  position: fixed;
  width: 100%;
  bottom: 0;
  z-index: 100;
}

.footer-info {
  display: flex;
  flex-direction: column;
  text-align: left;
  margin-right: 20px; /* Espacio entre info y links en desktop */
}

.footer-links {
  display: flex;
  flex-direction: column;
  text-align: right; /* Alineación izquierda en desktop */
}

.footer-links a {
  text-decoration: none;
  color: inherit;
}

@media (max-width: 768px) {
  .footer {
    flex-direction: row; /* Asegura que la info y los links estén en una fila en móvil */
    justify-content: space-between; /* Espacio entre ambos en móvil */
    padding: 10px;
    align-items: flex-end;
  }

  .footer-info {
    text-align: left;
    margin-left: 10px;
  }

  .footer-links {
    text-align: right;
    margin-right: 10px;
    align-items: flex-end;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/Footer.css"],"names":[],"mappings":"AAAA;EACE,wCAAwC;EACxC,gBAAgB;EAChB,aAAa;EACb,2BAA2B,EAAE,gCAAgC;EAC7D,aAAa;EACb,eAAe;EACf,6BAA6B,EAAE,cAAc;EAC7C,cAAc;EACd,eAAe;EACf,WAAW;EACX,SAAS;EACT,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB,EAAE,0CAA0C;AAChE;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB,EAAE,oCAAoC;AACzD;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE;IACE,mBAAmB,EAAE,+DAA+D;IACpF,8BAA8B,EAAE,iCAAiC;IACjE,aAAa;IACb,qBAAqB;EACvB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;EACvB;AACF","sourcesContent":[".footer {\n  font-family: \"CreatoDisplay\", sans-serif; \n  font-weight: 500; \n  display: flex;\n  justify-content: flex-start; /* Alinea ambos a la izquierda */\n  padding: 10px;\n  font-size: 10px;\n  background-color: transparent; /* Sin fondo */\n  color: #000000;\n  position: fixed;\n  width: 100%;\n  bottom: 0;\n  z-index: 100;\n}\n\n.footer-info {\n  display: flex;\n  flex-direction: column;\n  text-align: left;\n  margin-right: 20px; /* Espacio entre info y links en desktop */\n}\n\n.footer-links {\n  display: flex;\n  flex-direction: column;\n  text-align: right; /* Alineación izquierda en desktop */\n}\n\n.footer-links a {\n  text-decoration: none;\n  color: inherit;\n}\n\n@media (max-width: 768px) {\n  .footer {\n    flex-direction: row; /* Asegura que la info y los links estén en una fila en móvil */\n    justify-content: space-between; /* Espacio entre ambos en móvil */\n    padding: 10px;\n    align-items: flex-end;\n  }\n\n  .footer-info {\n    text-align: left;\n    margin-left: 10px;\n  }\n\n  .footer-links {\n    text-align: right;\n    margin-right: 10px;\n    align-items: flex-end;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
